const LOCAL_HOST_URL_PATTERN = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i;

const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

export const getPythonApiBaseUrl = () => {
  const configuredUrl = trimTrailingSlash(
    (process.env.REACT_APP_PYTHON_API_URL || "").trim()
  );

  if (!configuredUrl) {
    return "";
  }

  const isConfiguredLocalhost = LOCAL_HOST_URL_PATTERN.test(configuredUrl);
  const browserHost =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isBrowserLocal = browserHost === "localhost" || browserHost === "127.0.0.1";

  if (isConfiguredLocalhost && !isBrowserLocal) {
    return "";
  }

  return configuredUrl;
};
